/* ODOVENI – thema-JavaScript (winkelwagen-lade, zoeken, kleurkeuze, filters) */
(function () {
  'use strict';

  var T = window.theme || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

  function money(cents) {
    try {
      return new Intl.NumberFormat(T.locale || 'nl-BE', { style: 'currency', currency: T.currency || 'EUR' }).format(cents / 100);
    } catch (e) { return '€ ' + (cents / 100).toFixed(2).replace('.', ','); }
  }

  /* Kleurnamen -> hex (zelfde lijst als snippets/swatch-color.liquid) */
  var COLORS = {
    'creme': '#E7DFD0', 'cream': '#E7DFD0', 'taupe': '#A8988A', 'antraciet': '#4A4845', 'saliegroen': '#9AA68A', 'olijf': '#6B7A4B',
    'roest': '#A9532F', 'zand': '#CDB89A', 'cognac': '#9A5B33', 'zwart': '#2E2C2A', 'black': '#2E2C2A', 'grijs': '#8B8985',
    'lichtgrijs': '#8B8985', 'groen': '#3D5A47', 'ivoor': '#EDE6D8', 'mos': '#7C8463', 'terra': '#B0694A', 'naturel-eik': '#C9A57A',
    'eik': '#C9A57A', 'zwart-eik': '#3A3532', 'wit': '#F4F1EA', 'beige': '#D9CBB4', 'bruin': '#6E4B36', 'blauw': '#3F5670', 'oker': '#C08A2E'
  };
  function handle(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  function hexFor(name) { return COLORS[handle(name)] || '#CFC7BA'; }
  function shapeFor(type) {
    var t = String(type || '').toLowerCase();
    if (t.indexOf('bar') > -1) return 'stool';
    if (t.indexOf('horeca') > -1) return 'horeca';
    if (t.indexOf('fauteuil') > -1 || t.indexOf('lounge') > -1) return 'arm';
    if (t.indexOf('tafel') > -1) return 'table';
    return 'dining';
  }
  function illustration(shape, hex) {
    var tpl = $('#chair-templates');
    if (!tpl) return '';
    var el = tpl.content.querySelector('[data-shape="' + shape + '"]') || tpl.content.querySelector('[data-shape="dining"]');
    return el ? el.innerHTML.split('CURRENTHEX').join(hex) : '';
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(text) {
    var t = $('#toast');
    if (!t) return;
    t.textContent = text;
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('show'); }, 2800);
  }

  /* ---------- Lades (menu, winkelwagen) ---------- */
  var openId = null, lastFocus = null;
  function open(id) {
    close(true);
    var el = document.getElementById(id);
    if (!el) return;
    lastFocus = document.activeElement;
    openId = id;
    el.classList.add('open');
    $$('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    $('#scrim').classList.add('open');
    document.body.style.overflow = 'hidden';
    var f = el.querySelector('a[href], button:not([data-close]), input');
    if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function close(silent) {
    if (!openId) return;
    var el = document.getElementById(openId);
    if (el) el.classList.remove('open');
    $$('[aria-controls="' + openId + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    $('#scrim').classList.remove('open');
    document.body.style.overflow = '';
    openId = null;
    if (!silent && lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- Winkelwagen ---------- */
  function renderCart(cart) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    var empty = cart.item_count === 0;
    var e = $('#cart-empty'), lines = $('#cart-lines'), foot = $('#cart-foot');
    if (!lines) return;
    e.hidden = !empty; lines.hidden = empty; foot.hidden = empty;
    $('#cart-total').textContent = money(cart.total_price);
    var free = T.freeShipping || 20000;
    var rest = free - cart.total_price;
    $('#ship-text').innerHTML = rest > 0 ? 'Nog <strong>' + money(rest) + '</strong> tot gratis levering' : '<strong>Je bestelling wordt gratis geleverd</strong>';
    $('#ship-fill').style.width = Math.min(100, Math.round(cart.total_price / free * 100)) + '%';
    lines.innerHTML = cart.items.map(function (item) {
      var color = '';
      (item.options_with_values || []).forEach(function (o) { if (/^(kleur|color|colour)$/i.test(o.name)) color = o.value; });
      var visual = item.image
        ? '<img src="' + esc(item.image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2')) + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=240" alt="" loading="lazy">'
        : illustration(shapeFor(item.product_type), hexFor(color || item.variant_title));
      var variant = item.product_has_only_default_variant ? '' : '<span class="line__meta">' + esc(item.variant_title) + '</span>';
      return '<div class="line">' +
        '<a class="line__img" href="' + esc(item.url) + '">' + visual + '</a>' +
        '<div class="line__info">' +
          '<div class="line__top"><a href="' + esc(item.url) + '">' + esc(item.product_title) + '</a><span>' + money(item.final_line_price) + '</span></div>' +
          variant +
          '<div class="line__ctrl">' +
            '<div class="qty qty--sm"><button type="button" data-line="' + esc(item.key) + '" data-qty-to="' + (item.quantity - 1) + '" aria-label="Eén minder">−</button><output>' + item.quantity + '</output><button type="button" data-line="' + esc(item.key) + '" data-qty-to="' + (item.quantity + 1) + '" aria-label="Eén meer">+</button></div>' +
            '<button class="link-btn" type="button" data-line="' + esc(item.key) + '" data-qty-to="0">Verwijderen</button>' +
          '</div>' +
        '</div></div>';
    }).join('');
  }
  function fetchCart() {
    return fetch((T.routes && T.routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }
  function changeLine(key, qty) {
    return fetch((T.routes.cartChange || '/cart/change') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart).catch(function () { toast('Er ging iets mis. Probeer het opnieuw.'); });
  }
  function addToCart(form) {
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');
    return fetch((T.routes.cartAdd || '/cart/add') + '.js', {
      method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.data.description || res.data.message || 'Dit product kon niet worden toegevoegd.'); return; }
        return fetchCart().then(function () { open('cart'); });
      })
      .catch(function () { form.submit(); })
      .then(function () { if (btn) btn.removeAttribute('aria-busy'); });
  }

  /* ---------- Productkaarten: kleurkeuze ---------- */
  function pickCardSwatch(btn) {
    var card = btn.closest('[data-product-card]');
    if (!card) return;
    $$('[data-swatch]', card).forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
    var input = $('[data-variant-input]', card);
    if (input) input.value = btn.getAttribute('data-variant');
    var name = $('[data-swatch-name]', card);
    if (name) name.textContent = btn.getAttribute('data-label');
    var img = $('.card__photo', card);
    if (img && btn.getAttribute('data-image')) { img.removeAttribute('srcset'); img.src = btn.getAttribute('data-image'); }
    $$('.chair-fill', card).forEach(function (p) { p.setAttribute('fill', btn.getAttribute('data-hex')); });
    var add = $('[data-add-button]', card);
    if (add) {
      var ok = btn.getAttribute('data-available') === 'true';
      add.disabled = !ok;
      add.textContent = ok ? 'In winkelwagen' : 'Uitverkocht';
    }
  }

  /* ---------- Productpagina ---------- */
  function initProduct(section) {
    var json = $('[data-product-json]', section);
    if (!json) return;
    var product = JSON.parse(json.textContent);
    var form = $('[data-product-form]', section) || $('form[action*="/cart/add"]', section);
    var input = $('[data-variant-input]', section);
    var qty = $('[data-qty-input]', section);
    var selected = (product.variants.find(function (v) { return String(v.id) === input.value; }) || product.variants[0]).options.slice();
    var shape = shapeFor(product.type);
    var thumbs = $$('[data-thumb]', section);

    function current() { return product.variants.find(function (v) { return v.options.every(function (o, i) { return o === selected[i]; }); }); }
    function update() {
      var v = current();
      $$('[data-option-button]', section).forEach(function (b) { b.setAttribute('aria-pressed', String(selected[+b.getAttribute('data-index')] === b.getAttribute('data-value'))); });
      $$('[data-option-label]', section).forEach(function (l) { l.textContent = selected[+l.getAttribute('data-option-label')]; });
      $$('[data-option-select]', section).forEach(function (s) { s.value = selected[+s.getAttribute('data-index')]; });
      var add = $('[data-add-button]', section);
      if (!v) { if (add) { add.disabled = true; add.textContent = 'Niet beschikbaar'; } return; }
      input.value = v.id;
      $('[data-price]', section).textContent = money(v.price);
      var cmp = $('[data-compare]', section);
      if (cmp) { cmp.hidden = !(v.compare_at_price > v.price); if (v.compare_at_price) cmp.textContent = money(v.compare_at_price); }
      if (add) {
        add.disabled = !v.available;
        add.innerHTML = v.available ? 'In winkelwagen · <span data-total>' + money(v.price * Math.max(1, +qty.value || 1)) + '</span>' : 'Uitverkocht';
      }
      var sb = $('[data-sticky-button]', section), sp = $('[data-sticky-price]', section);
      if (sb) { sb.disabled = !v.available; sb.textContent = v.available ? 'In winkelwagen' : 'Uitverkocht'; }
      if (sp) sp.textContent = money(v.price);
      var main = $('[data-main-media]', section);
      if (v.featured_media && main && $('.pdp__photo', main) && thumbs.length) {
        var idx = thumbs.findIndex(function (x) { return x.getAttribute('data-media-id') === String(v.featured_media.id); });
        if (idx > -1) showPhoto(idx);
      } else if (v.featured_image && main && $('.pdp__photo', main)) {
        var img = $('.pdp__photo', main);
        img.removeAttribute('srcset');
        img.src = v.featured_image.src + (v.featured_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=1400';
      } else if (main && !$('.pdp__photo', main)) {
        var colorIdx = -1;
        (product.options || []).forEach(function (o, i) { var n = (o.name || o).toString(); if (/^(kleur|color|colour)$/i.test(n)) colorIdx = i; });
        if (colorIdx > -1) $$('.chair-fill', main).forEach(function (p) { p.setAttribute('fill', hexFor(selected[colorIdx])); });
      }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    section.addEventListener('click', function (e) {
      var b = e.target.closest('[data-option-button]');
      if (b) { selected[+b.getAttribute('data-index')] = b.getAttribute('data-value'); update(); return; }
      var q = e.target.closest('[data-qty]');
      if (q) { qty.value = Math.max(1, (+qty.value || 1) + +q.getAttribute('data-qty')); update(); return; }
      var th = e.target.closest('[data-thumb]');
      if (th) { showPhoto($$('[data-thumb]', section).indexOf(th)); return; }
      var step = e.target.closest('[data-gallery-step]');
      if (step) { go(+step.getAttribute('data-gallery-step')); }
    });

    /* Fotogalerij: miniaturen, pijltjes, swipen en pijltoetsen */
    function currentPhoto() { var i = thumbs.findIndex(function (x) { return x.getAttribute('aria-pressed') === 'true'; }); return i < 0 ? 0 : i; }
    function showPhoto(i) {
      if (!thumbs.length) return;
      i = (i + thumbs.length) % thumbs.length;
      var img = $('.pdp__photo', section);
      if (img) { img.removeAttribute('srcset'); img.src = thumbs[i].getAttribute('data-thumb'); }
      thumbs.forEach(function (x, j) { x.setAttribute('aria-pressed', String(j === i)); });
      var n = $('[data-gallery-index]', section);
      if (n) n.textContent = i + 1;
      var row = $('[data-thumbs]', section);
      if (row) {
        var b = thumbs[i];
        var left = b.offsetLeft - row.offsetLeft;
        if (left < row.scrollLeft || left + b.offsetWidth > row.scrollLeft + row.clientWidth) row.scrollTo({ left: left - 8, behavior: 'smooth' });
      }
    }
    function go(d) { showPhoto(currentPhoto() + d); }
    var mainBox = $('[data-main-media]', section);
    if (mainBox && thumbs.length > 1) {
      var sx = null;
      mainBox.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      mainBox.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
        sx = null;
      });
      mainBox.setAttribute('tabindex', '0');
      mainBox.setAttribute('aria-label', 'Productfoto’s, gebruik de pijltoetsen om te bladeren');
      mainBox.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      });
    }
    section.addEventListener('change', function (e) {
      var s = e.target.closest('[data-option-select]');
      if (s) { selected[+s.getAttribute('data-index')] = s.value; update(); }
      if (e.target === qty) update();
    });
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(form); });

    var bar = $('[data-sticky-buy]', section), mainBtn = $('[data-add-button]', section);
    if (bar && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', String(!show));
        var b = $('[data-sticky-button]', bar);
        if (b) b.tabIndex = show ? 0 : -1;
      }).observe(mainBtn);
    }
  }

  /* ---------- Gerelateerde producten ---------- */
  function initRecommendations() {
    var box = $('[data-recommendations]');
    if (!box || box.children.length) return;
    fetch(box.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var fresh = tmp.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) box.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  }

  /* ---------- Zoeken ---------- */
  function initSearch() {
    var form = $('[data-search]');
    if (!form) return;
    var q = $('.search__input', form), results = $('.search__results', form), clear = $('.search__clear', form);
    var timer, lastTerm = '';
    function hide() { results.classList.remove('open'); q.setAttribute('aria-expanded', 'false'); }
    function run() {
      var term = q.value.trim();
      clear.classList.toggle('show', term.length > 0);
      if (!term) { hide(); results.innerHTML = ''; return; }
      lastTerm = term;
      var url = (T.routes.predictiveSearch || '/search/suggest') + '.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url).then(function (r) { return r.json(); }).then(function (data) {
        if (term !== lastTerm) return;
        var items = (data.resources && data.resources.results && data.resources.results.products) || [];
        results.innerHTML = items.length ? items.map(function (p) {
          var img = p.featured_image && p.featured_image.url
            ? '<img src="' + esc(p.featured_image.url) + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" loading="lazy">'
            : illustration(shapeFor(p.type), '#CDB89A');
          var price = p.price ? money(Math.round(parseFloat(p.price) * 100)) : '';
          return '<a class="result" href="' + esc(p.url) + '"><span class="result__img">' + img + '</span><span class="result__txt"><strong>' + esc(p.title) + '</strong><small>' + esc(p.type || '') + '</small></span><strong>' + price + '</strong></a>';
        }).join('') + '<a class="result" href="' + esc(T.routes.search) + '?q=' + encodeURIComponent(term) + '&type=product" style="justify-content:center;font-weight:600">Alle resultaten bekijken</a>'
          : '<p class="search__none">Geen producten gevonden voor “' + esc(term) + '”. Probeer “stoel”, “barkruk”, “horeca”, “fauteuil” of “tafel”.</p>';
        results.classList.add('open');
        q.setAttribute('aria-expanded', 'true');
      }).catch(hide);
    }
    q.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 180); });
    q.addEventListener('focus', function () { if (q.value.trim() && results.innerHTML) results.classList.add('open'); });
    clear.addEventListener('click', function () { q.value = ''; run(); q.focus(); });
    document.addEventListener('click', function (e) { if (!e.target.closest('[data-search]')) hide(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && results.classList.contains('open')) { hide(); q.focus(); } });
  }

  /* ---------- Filterknoppen op de homepage ---------- */
  function initPills() {
    $$('[data-pills]').forEach(function (group) {
      var section = group.closest('section');
      group.addEventListener('click', function (e) {
        var b = e.target.closest('[data-pill]');
        if (!b) return;
        var f = b.getAttribute('data-pill');
        $$('[data-pill]', group).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        var shown = 0;
        $$('[data-product-card]', section).forEach(function (c) {
          var match = !f || c.getAttribute('data-type') === f;
          c.hidden = !match;
          if (match) shown++;
        });
        var none = $('[data-grid-empty]', section);
        if (none) none.hidden = shown > 0;
      });
    });
  }

  /* ---------- Sorteren op collectiepagina ---------- */
  function initSort() {
    $$('[data-sort]').forEach(function (s) {
      s.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', s.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  /* ---------- Klikken ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('a, button');
    if (!t) return;
    if (t.hasAttribute('data-open')) { e.preventDefault(); var id = t.getAttribute('data-open'); if (openId === id) close(); else { if (id === 'cart') fetchCart(); open(id); } return; }
    if (t.hasAttribute('data-close')) { close(t.tagName !== 'A'); }
    if (t.hasAttribute('data-swatch')) { pickCardSwatch(t); return; }
    if (t.hasAttribute('data-qty-to')) { changeLine(t.getAttribute('data-line'), +t.getAttribute('data-qty-to')); return; }
  });
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.hasAttribute('data-add-form')) { e.preventDefault(); addToCart(form); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  function initAnnounce() {
    var bar = $('.announce');
    if (!bar) return;
    var items = $$('.announce__item', bar);
    if (items.length < 2) return;
    var i = 0;
    items[0].classList.add('is-active');
    setInterval(function () {
      if (document.hidden || bar.matches(':focus-within')) return;
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4000);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var scrim = $('#scrim');
    if (scrim) scrim.addEventListener('click', function () { close(); });
    $$('[data-product-section]').forEach(initProduct);
    initRecommendations();
    initSearch();
    initPills();
    initSort();
    initAnnounce();
    fetchCart().catch(function () {});
  });
})();
